/*Initialisation des variables utilisées ci-dessous par le AbortController()*/

let controller;

/**
 * Fetch Data for autocompleting fields from a select and an ajax request
 * @param {string} url the remote url
 * @param {string} fields the fields to return
 * @param {boolean} isAbsoluteUrl if third-party API
 * @param {function} manageError function to display alert if a network error appears
 * @param {function} t Translate
 * @returns {Promise<any>}
 * @constructor
 */
const FillSelectFetch = (url, fields, isAbsoluteUrl = false, manageError, t) => {
    const token = localStorage.getItem('token');
    let headers = {};

    if (!token) {
        manageError(401, {});
    }

    url = isAbsoluteUrl ? url : `${process.env.REACT_APP_HOST_API}${url}`;
    
    if (!isAbsoluteUrl) {
        headers = {
            'Content-Type': 'application/json',
            Accept: 'application/ld+json',
            "X-POL-AUTH": 'Bearer ' + token
        }
    }
    /*Si une requête est en cours alors qu'une nouvelle vient d'être soumise*/
    if (controller) {
        /*Supression de la requete en cours*/
        controller.abort();
    }

    if ("AbortController" in window) {
        /*Définition d'une nouvelle instance de la class AbortController*/
        controller = new AbortController();
    }
    return fetch(url, {
        signal: controller.signal,
        headers: headers
    })
        .then(res => res.json())
        .then(response => {
            let resultToReturn = {};
            fields.forEach((key) => {
                resultToReturn[key] = response[key];
            })
            return resultToReturn;
        })
        .catch(error => {
            /*Si l'erreur est pas dû à l'abort du fetch*/
            if (error.name !== 'AbortError') {
                /*Faire disparaître le loader et apparaître une erreur lors de la requete.*/
                manageError(500, {}, t('err_loading_auto_complete'))
            }
        });
};

export default FillSelectFetch;
